import React from 'react';
import PropTypes from 'prop-types';
import { Menu as SemanticUIMenu } from 'semantic-ui-react';
import BaseLink from '../../../../../atoms/Link';
import { isExternalPage } from '../../../../../services/pages';
import { LinkDisplayName } from '../../SiteNavigation.constants';

const propTypes = {
  pageType: PropTypes.string,
  url: PropTypes.string,
  slug: PropTypes.string,
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  title: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  contentProps: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  extraLinkProps: PropTypes.object,
};

const defaultProps = {
  pageType: 'Internal',
  url: '',
  slug: '',
  as: 'span',
  title: null,
  contentProps: {},
  extraLinkProps: {},
};

function Link({ pageType, url, slug, as, title, contentProps, extraLinkProps, ...props }) {
  return (
    <SemanticUIMenu.Item link {...props}>
      <BaseLink
        to={isExternalPage(pageType) ? url : slug}
        linkAs={as}
        title={title}
        internal={!isExternalPage(pageType)}
        contentProps={contentProps}
        {...extraLinkProps}
      />
    </SemanticUIMenu.Item>
  );
}

Link.propTypes = propTypes;
Link.defaultProps = defaultProps;
Link.displayName = LinkDisplayName;

export default Link;
